<template>
  <SectionLayout :section-title="sectionTitle" section-key="faqs" :loading="loadingDashboard">
    <template #headerAction>
      <a href="https://help.gempages.net/faqs" target="_blank" class="d-flex align-items-center dashboard__link">
        <!-- Read More -->
        <span class="paragraph-14-16-medium dashboard__link-txt">{{ viewAll }}</span>
      </a>
    </template>
    <template>
      <template v-for="(faq, index) in faqs">
        <div class="bg-light1 clickable dashboard__faq" v-if="faq" :class="getItemDynamicClass(index)" :key="index" @click="doAction(faq.action)">
          <p class="txt-dark-high-contrast heading-h6-14-semi dashboard__faq-title mb-1">{{ faq.title }}</p>
          <div class="d-flex align-items-center">
            <span class="text-dark6 body-12-regular mr-1 dashboard__faq-category" v-if="faq.category">{{ faq.category }}</span>
            <span class="body-12-regular dashboard__faq-read" v-if="faq.timeReading">{{ faq.timeReading }}</span>
          </div>
        </div>
        <div class="bg-light1 clickable dashboard__faq" v-else :key="index">
          <div class="d-flex align-items-center mb-1">
            <div class="faq__loading-short skeleton-light-grey-200 "></div>
            <span class="dashboard__faq-dot">
              <i class="icon icon-uniE906"></i>
            </span>
            <div class="faq__loading-short skeleton-light-grey-200 "></div>
          </div>
          <div class="faq__loading-long skeleton-light-grey-200 "></div>
        </div>
      </template>
    </template>
  </SectionLayout>
</template>

<script>
import SectionLayout from "./SectionLayout.vue";
import ActionMixin from "./ActionMixin";
import { mapGetters } from "vuex";

export default {
  name: "Faqs",
  components: {
    SectionLayout
  },
  mixins: [ActionMixin],
  data: () => ({
    linkIconSrc: require("@/core/assets/new-dashboard/link.svg")
  }),
  computed: {
    ...mapGetters("account", {
      lang: "displayLanguage"
    }),
    ...mapGetters("dashboard", {
      allFaqs: "faqs",
      loadingDashboard: "loading"
    }),
    sectionTitle() {
      return this.$t("agency.faqs.title");
    },
    viewAll() {
      return this.$t("dashboard.viewAll");
    },
    faqs() {
      if (this.loadingDashboard) {
        return [null, null, null, null];
      }
      const lang = this.lang;
      const defaultLang = "en";
      return this.allFaqs.map(data => {
        return {
          title: !data.title[lang] ? data.title[defaultLang] : data.title[lang],
          action: !data.action[lang] ? data.action[defaultLang] : data.action[lang],
          category: !data.category[lang] ? data.category[defaultLang] : data.category[lang],
          timeReading: !data.timeReading[lang] ? data.timeReading[defaultLang] : data.timeReading[lang]
        };
      });
    }
  },
  methods: {
    getItemDynamicClass(index) {
      return {
        "mt-2": index > 0
      };
    }
  }
};
</script>

<style lang="scss">
.dashboard {
  &__faq {
    border: solid 1px #d6d6d6;
    padding: 12px 16px;
    border-radius: 5px;
    &:hover {
      border: 1px solid #5B5B5B;
    }
    &-category, &-read {
      line-height: 150% !important;
    }
    &-read {
      color: $textLightModeDisabled !important;
    }
  }
}
.faq {
  &__loading {
    &-short {
      width: 60px;
      height: 16px;
    }

    &-long {
      width: 100%;
      height: 16px;
    }
  }
}
</style>
